import { Application as ABCApplication } from '@barthauer/abc/init';

export class Application extends ABCApplication {
  public static init() {
    super.init();
  }
}
